export const IMAGE_TYPE_CLIPPING_BANK = "ClippingEngineAnswerVariantImageBankDto";
export const IMAGE_TYPE_CLIPPING_UPLOAD = "ClippingEngineAnswerVariantImageQuestionDto";
export const IMAGE_TYPE_SECONDARY_CLIPPING_UPLOAD =
    "ClippingSecondaryEngineAnswerVariantImageQuestionDto";
export const IMAGE_TYPE_SECONDARY_CLIPPING_BANK =
    "ClippingSecondaryEngineAnswerVariantImageBankDto";
